import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdersService } from 'src/app/services/orders/orders.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AppTablesComponent } from '../../myapps/app-tables/app-tables.component';
import { SpinnerComponent } from "../../../layout/spinner/spinner.component";
import { NgZone } from '@angular/core';
import { AppService } from 'src/app/services/app/app.service';
import { PackMinimalComponent } from "../../../layout/pack-minimal/pack-minimal.component";
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [TranslateModule, CommonModule, AppTablesComponent, SpinnerComponent, PackMinimalComponent, NgbCollapseModule],
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent {
  id: number = 0;
  orders: any[] = [];
  newOrder: any = { app_id: '', products: '' };
  audio = new Audio('assets/notification-sound.mp3'); // დაამატეთ თქვენი აუდიო ფაილის პათი
  soundEnabled = false;
  customerInfoVisible: boolean[] = [];

  loadingMap: { [key: string]: boolean } = {};

  knownOrderIds: string[] = [];
  previousOrderIDs: string[] = [];
  isMinimal = false
  loadCheck = false

  isTable = false

  constructor(
    private ordersService: OrdersService,
    private activatedRoute: ActivatedRoute,
    private adminService: AdminService,
    private ngZone: NgZone,
    private AppService: AppService,
    private Router: Router
  ) { 
    this.activatedRoute.params.subscribe(
      params => {
        if (params['id']) {
          this.id = params['id']; // convert to number
        }
      }
    );

    this.loadCheck = true   
    this.AppService.checkAppOneAuth(this.id).subscribe(
      (res: any) => {
        this.loadCheck = false   
        
        console.log('app: ', res.data)
        if(res.data.package === 'minimal'){
          this.isMinimal = true
        }
      },
      (error: any) => {
        this.loadCheck = false  
          Router.navigate(['/'])
      }
    )

    this.fetchOrders();
  
    // შეამოწმეთ ახალი შეკვეთები ყოველ 10 წამში
    setInterval(() => {
        // console.log('🕒 Running fetchOrders interval');
        this.fetchOrders(true);
      }, 10000);
  }

  checkApp(){
    
  }


  fetchOrders(isSilent: boolean = false) {
    // console.log('🕒 Running fetchOrders interval');

    this.ordersService.getOrders(this.adminService.user.id.toString(), this.id.toString()).subscribe(
      (res: any) => {
        // console.log('📦 Orders received from server:', res);

        const newOrderIDs = res.map((o: any) => o.id);
        // console.log('⬅️ Previous order IDs:', this.previousOrderIDs);
        const hasNewOrder = newOrderIDs.some((id: any) => !this.previousOrderIDs.includes(id));
        // console.log('🔔 Has new order?', hasNewOrder);

        if (
          Array.isArray(this.previousOrderIDs) &&
          this.previousOrderIDs.length > 0 &&
          hasNewOrder
        ) {
          // alert('ახალი შეკვეთაა!');
          this.playNotificationSound();
        }

        this.previousOrderIDs = newOrderIDs;
        this.orders = res.sort((a: any, b: any) => b.id - a.id);
      },
      (error: any) => {
        console.error(error);
      }
    );
  }
  enableSound() {
    this.soundEnabled = true;
    this.audio.play().catch(error => console.error('Error playing sound:', error));
  }

  playNotificationSound() {
    this.audio.play()
      .then(() => console.log('✅ Sound played'))
      .catch(err => console.error('❌ Error playing sound:', err));
  }
  // ღილაკზე დაჭერის ფუნქცია - შეკვეთის დადასტურება
  confirmOrder(orderId: string): void {
    const data = {
      userId: this.adminService.user.id.toString(),
      appId: this.id.toString(),
      orderId: orderId
    };
  
    this.ordersService.confirmOrder(data).subscribe(() => {
      // console.log(`Order ${orderId} confirmed!`);
  
      // მოძებნეთ შეკვეთა orders მასივში და განაახლეთ მისი სტატუსი
      const order = this.orders.find(o => o.id === orderId);
      if (order) {
        order.status = 'confirmed'; // ან შესაბამისი სტატუსი
      }
    }, (error: any) => {
      console.error('Error confirming order:', error);
    });
  }

  // ღილაკზე დაჭერის ფუნქცია - სტატუსის განახლება
  updateStatus(orderId: string, newStatus: string, key?: string): void {
    const loadingKey = key || `${orderId}_${newStatus}`;
    this.loadingMap[loadingKey] = true;

    const data = {
      userId: this.adminService.user.id.toString(),
      appId: this.id.toString(),
      orderId: orderId,
      newStatus: newStatus
    };

    this.ordersService.confirmOrder(data).subscribe(
      (res: any) => {
        const order = this.orders.find(o => o.id === orderId);
        if (order) {
          order.status = newStatus;
        }
        this.loadingMap[loadingKey] = false;
      },
      (error: any) => {
        console.error('Error:', error);
        this.loadingMap[loadingKey] = false;
      }
    );
  }
  
  notifyRelevantParty(newStatus: string, orderId: string) {
    // თუ სტატუსი "Ready for Transport"-ია და შეკვეთა არის TAKEAWAY, ვაცნობოთ მომხმარებელს
    if (newStatus === 'Ready for Transport') {
      const order = this.orders.find(o => o.id === orderId);
      
      if (order.type === 'TAKEAWAY') {
        console.log(`Notify customer that order ${orderId} is ready for pickup.`);
        // აქ დაამატეთ თქვენი ლოგიკა, რომელიც მომხმარებელს გაუგზავნის შეტყობინებას
        // this.sendPickupNotification(order.customer_phone, orderId); // SMS ან სხვა მეთოდით ინფორმირება
      } else if (order.type === 'DELIVERY') {
        console.log(`Notify delivery personnel for order ${orderId}`);
      }
    } else if (newStatus === 'In Transit') {
      console.log(`Notify customer that order ${orderId} is on the way.`);
      // აქ დაამატეთ ლოგიკა, თუ გსურთ კურიერს გაუგზავნოთ შეტყობინება
    }
  }
  
  nextStep(order: any) {
    const key = order.id + '_NextStep';
    this.loadingMap[key] = true;

    if (order.type === 'DINE IN') {
      // თუ შეკვეთა არის ადგილზე მომსახურებისთვის
      this.updateStatus(order.id, 'Completed', key); // სტატუსის განახლება "Completed"-ზე
    } else if (order.type === 'DELIVERY') {
      // თუ შეკვეთა არის მიტანისთვის
      console.log('Preparing order for transport, updating status to Ready for Transport...');
      this.updateStatus(order.id, 'Ready for Transport', key); // სტატუსის განახლება "Ready for Transport"-ზე
    } else if (order.type === 'TAKEAWAY') {
      // თუ შეკვეთა არის წასაღებად და მიტანის სერვისი არ არის საჭირო
      console.log('Order ready for pickup, updating status to Ready for Pickup...');
      this.updateStatus(order.id, 'Ready for Pickup', key); // სტატუსის განახლება "Ready for Pickup"-ზე
    }
  }

  // sendPickupNotification(phone: string, orderId: string): void {
  //   console.log(`Sending SMS notification to customer with phone ${phone} for order ${orderId}`);
  
  //   // აქ შეგიძლიათ ჩაწეროთ თქვენი შეტყობინების გაგზავნის API ან SMS სერვისი
  //   // მაგალითად:
  //   this.smsService.sendSMS(phone, `Your order ${orderId} is ready for pickup.`);
  // }

  toggleCustomerInfo(index: number) {
    // მობრუნება true/false
    this.customerInfoVisible[index] = !this.customerInfoVisible[index];
  }



  // შეკვეთის დასრულების ფუნქცია
  completeOrder(orderId: string): void {
    const order = this.orders.find(o => o.id === orderId);

    console.log('არქივში გადასატანი შეკვეთა: ', order)
    this.saveArcive(order)
    // Firebase-დან შეკვეთის წაშლა
    // this.ordersService.deleteOrderFromFirebase(orderId).then(() => {
    //   // console.log(`შეკვეთა ${orderId} წაშლილია`);
    // }).catch((error: any) => {
    //   console.error('Error deleting order from Firebase:', error);
    // });
  }

  saveArcive(order: any){
    console.log(`შევინახოთ ბაზაში `, order);
    this.ordersService.saveArcive(order).subscribe(
      (res: any) => {
        console.log(res)
      },
      (error: any) => {
        console.log(error)
      }
    )
  }


}